export default __webpack_public_path__ + "0647116bec6a62f356869876dbd9b556.png";